import { Box, Flex, type FlexProps, Text } from '@/ui';

type Props = Omit<FlexProps, 'title'> & {
  title: string;
  description?: string;
  /** Drops the leading rule for the first section in a panel. */
  first?: boolean;
};

// A titled block within a settings panel: hairline, sentence-case heading, and
// an optional one-line explanation. Distinct from SectionHeader, which is the
// all-caps micro-label used for a panel's top-level context row.
export const PanelSection = ({
  title,
  description,
  first,
  children,
  ...flexProps
}: Props) => (
  <Flex
    borderTopColor="gray.200"
    borderTopWidth={first ? 0 : '1px'}
    direction="column"
    gap="4"
    mt={first ? 0 : 6}
    pt={first ? 0 : 6}
    {...flexProps}
  >
    <Box>
      <Text fontSize="lg" fontWeight="medium">
        {title}
      </Text>
      {description && (
        <Text color="customgray.mid" fontSize="sm">
          {description}
        </Text>
      )}
    </Box>
    {children}
  </Flex>
);
